import {
  WSCheckboxToggle,
  WSElement,
  WSElementProps,
  WSForm,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useFormContext } from "react-hook-form";
import { Hidden } from "../Hidden/Hidden";

export type AdvancedSectionValues = {
  advanced: {
    sendEmails: boolean;
    sendReminders: boolean;
    clientPaysProcessingFees: boolean;
  };
};

type Props = {} & WSElementProps;

export const AdvancedSection: React.FC<Props> = ({ ...elementProps }) => {
  const { setValue } = useFormContext();

  return (
    <WSElement {...elementProps}>
      <WSText.Heading3 mb="S">Advanced</WSText.Heading3>

      <Hidden name="advanced">
        <WSForm.Field
          name="advanced.sendEmails"
          component={WSCheckboxToggle}
          componentProps={{
            label: "Send invoice to client",
            description:
              "When this invoice is sent, client is emailed invoice payment link and PDF",
            onChange: value => {
              if (!value) {
                setValue("advanced.sendReminders", false);
              }
            }
          }}
          mb="M"
        />

        <WSForm.Value name="advanced.sendEmails">
          {sendEmails => (
            <WSElement
              style={{
                opacity: sendEmails ? 1 : 0.5,
                pointerEvents: sendEmails ? undefined : "none"
              }}
            >
              <WSForm.Field
                name="advanced.sendReminders"
                component={WSCheckboxToggle}
                componentProps={{
                  label: "Remind client to pay invoice",
                  description:
                    "Send reminder emails when invoice is almost due and overdue"
                }}
                mb="M"
              />
            </WSElement>
          )}
        </WSForm.Value>

        <WSForm.Field
          name="advanced.clientPaysProcessingFees"
          component={WSCheckboxToggle}
          componentProps={{
            label: "Client pays processing fees",
            description:
              "If your client chooses to pay with a credit card, processing fees will be passed onto them."
          }}
          mb="M"
        />
      </Hidden>
    </WSElement>
  );
};
